import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {Illustration} from 'shells/illustrations/illustration';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import type {MonthlyUsage} from '../../limits/get-usage-from-limits';

import type {PowerAiVariant} from './ai-usage-popover';

import styles from './power-ai-usage-popover.module.css';

export const getUsageVerbage = (monthlyUsage?: MonthlyUsage | null) => {
    if (NutClientConfig.hasAiOutcomesFF) {
        return monthlyUsage && monthlyUsage.remaining === 1 ? 'outcome' : 'outcomes';
    }

    return monthlyUsage && monthlyUsage.remaining === 1 ? 'summary' : 'summaries';
};

export const generateTitleBody = (variant: PowerAiVariant) => {
    switch (variant) {
        case 'timeline':
            return {
                title: 'Summarize this timeline',
                body: (
                    <>
                        Nutshell uses AI to analyze your timeline interactions and provide you with
                        a brief summary.
                    </>
                ),
            };
        case 'zoom':
        default:
            return {
                title: 'Summarize this transcription',
                body: (
                    <>
                        Nutshell uses AI to generate a brief summary of your Zoom meeting
                        transcriptions.
                    </>
                ),
            };
    }
};

export const getLimitsContent = (
    isLoading: boolean,
    monthlyUsage?: MonthlyUsage | null,
    error?: boolean
) => {
    if (isLoading) {
        return (
            <div className='flex justify-center'>
                <LoadingIcon size={24} />
            </div>
        );
    }

    if (monthlyUsage) {
        return (
            <div>
                Your team has <strong>{monthlyUsage.remaining.toLocaleString()}</strong>{' '}
                {getUsageVerbage(monthlyUsage)} left out of{' '}
                <strong>
                    {monthlyUsage.limit ? monthlyUsage.limit.toLocaleString() : 'unlimited'}
                </strong>{' '}
                per month.
            </div>
        );
    }

    if (error) {
        return (
            <StackLegacy spacing={8} isHorizontal={true} alignCenter={true}>
                <div className={styles['error-svg-container']}>
                    <Illustration src='plug-error-state' />
                </div>
                <div>Something went wrong fetching this response. Try again in a bit!</div>
            </StackLegacy>
        );
    }

    return null;
};
